module.exports = __webpack_public_path__ + "img/step-two-img.2051453.svg";